module.exports = __webpack_public_path__ + "static/media/logo-novaiorque.e1fa7cf6.png";